import React from 'react';

interface Props {
  content: string;
  expertsInfo?: { id: number; name: string }[];
}

const UzyToolGondang: React.FC<Props> = ({ content, expertsInfo }) => {
  let ticket: Record<string, any> = {};
  try { ticket = JSON.parse(content); } catch { /* ignore */ }
  const expertName = expertsInfo?.find(e => e.id === ticket.expert_id)?.name || String(ticket.expert_id ?? '');
  return (
    <div className="uzy-tool-card">
      <div className="uzy-tool-card-header">工单：{ticket.title || ''}</div>
      <div className="uzy-tool-card-body">
        <div>分类：{ticket.category || ''}</div>
        <div>描述：{ticket.problem_description || ''}</div>
        <div>分派的专家：{expertName}</div>
      </div>
    </div>
  );
};

export default UzyToolGondang;
